import { EventEmitter } from 'events';
const eventBus = new EventEmitter();
export default eventBus;

// 全局触发 会员套餐弹窗
export const OPEN_VIP_MODAL = 'OPEN_VIP_MODAL';
